import { Loader } from "lucide-react";
import { parse } from "qs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useZustandStore from "@src/helpers/zustand";
import Container from "@src/components/shared/Container";
import { usePartnerProcess } from "@src/api/usePartnerProcess";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import animationData from "@src/assets/lottie/Warning.json";
import { getErrorUrl } from "@src/utils/consts";
import Player from "lottie-react";

function ConnectToken() {
  const { hash } = useLocation();
  const saveData = usePartnerProcess();
  const { data } = useZustandStore();
  const [noData, setNoData] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!hash) return;
    const parsed = parse(hash.substring(1));
    const accessToken = parsed.access_token;
    const state = parsed.state;
    if (data.guid !== state || !accessToken) {
      setNoData(true);
      return;
    }
    saveData.mutate({
      apiKey: data.apiKey,
      processKey: accessToken as string,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hash) {
    return <div />;
  }

  return (
    <Container>
      {noData ? (
        <>
          <div className="py-6">
            <TitleAndDesc
              desc={t("connectToken.title")}
              title={t("somethingWentWrong")}
            />
          </div>
          <div className="flex flex-1 items-center justify-center max-md:min-h-[60vh]">
            <div className="mx-auto h-[180px] w-[180px]">
              <Player
                loop={false}
                autoplay={true}
                animationData={animationData}
                rendererSettings={{
                  preserveAspectRatio: "xMidYMid slice",
                }}
              />
            </div>
          </div>
          <div
            className="w-full self-end rounded-[6px] bg-white py-8
         max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
          >
            <a className="w-full" href={getErrorUrl(i18n.language)}>
              <Button className="w-full">{t("back")}</Button>
            </a>
          </div>
        </>
      ) : (
        <div className="flex justify-center items-center h-[70vh]">
          <div
            className="animate-spin"
            style={{
              animationDuration: "1.5s",
            }}
          >
            <Loader className="text-gray-700" size={60} />
          </div>
        </div>
      )}
    </Container>
  );
}

export default ConnectToken;
